import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppComponent} from './app.component';
import {AuthService, AuthUser, Customer, TokenService} from './core/auth';
import {ProfileService} from './core/services/profile.service';
import {User} from './core/models/user';
import {HeartbeatService} from './core/heartbeat.service';
import {Subscription} from 'rxjs';
import {TopbarService} from './topbar.service';
import {Router} from '@angular/router';
import {DemoService} from './core/services';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit, OnDestroy {

    authUser: AuthUser = this.token.whoAmI();
    user: User;
    subscriptionAvatar: Subscription;
    subscriptionCurrentCustomer: Subscription;

    currentCustomer: Customer;


    constructor(
        public app: AppComponent,
        private token: TokenService,
        private profileService: ProfileService,
        private topbarService: TopbarService,
        private authService: AuthService,
        private demoService: DemoService,
        private router: Router,
        private heartbeatService: HeartbeatService
    ) {
    }

    ngOnInit(): void {
        this.app.changeTheme(this.getTheme());
        this.subscriptionAvatar = this.topbarService.avatarHandler.subscribe(response => {
            this.user = response;
        });

        this.subscriptionCurrentCustomer = this.topbarService.customerHandler.subscribe(response => {
            this.currentCustomer = response;
        });

        this.currentCustomer = this.authUser.currentCustomer;

        // initial load
        this.profileService.get().subscribe(
            (data) => { this.user = data; }
        );
    }

    showSwitchToCustomer() {
        return this.authUser.loginCustomer.name != this.currentCustomer.name;
    }

    generateDemoData() {
        this.demoService.generateDemoData().subscribe(
        );
    }

    switchToCustomer() {
        this.authService.switchCustomer(this.authUser.username, this.authUser.loginCustomer.name).subscribe(
            (data) => {
                this.token.saveToken(data.token);
                this.authUser = this.token.whoAmI();
                this.topbarService.setCustomerItems(this.authUser.currentCustomer);
                this.router.navigate(['/project', 'list']);
            }
        );
    }

    logout() {
        this.token.signOut();
    }

    ngOnDestroy() {
        if (this.subscriptionAvatar) {
            this.subscriptionAvatar.unsubscribe();
        }
    }

    getTheme() {
        let theme = localStorage.getItem('theme');
        if (!theme || (theme !== 'light' && theme !== 'dark')) {
            theme = 'light';
        }
        const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
        const href = themeLink.href;
        const themeFile = href.substring(href.lastIndexOf('/') + 1, href.lastIndexOf('.'));
        const themeTokens = themeFile.split('-');
        const themeName = themeTokens[1];

        return themeName + '-' + theme;
    }


    themeChange(event: any) {
        const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
        const href = themeLink.href;
        const themeFile = href.substring(href.lastIndexOf('/') + 1, href.lastIndexOf('.'));
        const themeTokens = themeFile.split('-');
        const themeName = themeTokens[1];
        const themeMode = themeTokens[2];
        const newThemeMode = (themeMode === 'dark') ? 'light' : 'dark';

        this.app.changeTheme(themeName + '-' + newThemeMode);
    }
}
